import { defineMessages } from 'react-intl';

const _default_1: {
	discardMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	keepButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stopMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yesButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	discardMessage: {
		id: 'ai-mate.inline-chat-input.warning-view.discard.message',
		defaultMessage: 'Cancel request and discard response?',
		description:
			'Confirmation message displayed in a dialog or modal when a user attempts to cancel an in-progress AI request or discard a generated response in the inline chat interface. Shown as the main question text in a confirmation dialog. The purpose is to ask the user to confirm whether they want to cancel the current request and discard any response that has been generated, ensuring they understand the action will result in losing the AI-generated content.',
	},
	deleteMessage: {
		id: 'ai-mate.inline-chat-input.warning-view.message',
		defaultMessage: 'Delete response?',
		description:
			'Confirmation message displayed in a dialog or modal when a user attempts to delete an AI-generated response in the inline chat interface. Shown as the main question text in a confirmation dialog. The purpose is to ask the user to confirm whether they want to permanently delete the AI-generated response, ensuring they understand the action cannot be undone.',
	},
	deleteButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.delete-button.label',
		defaultMessage: 'Delete',
		description:
			'Button label displayed on the confirm/delete button in a confirmation dialog when deleting an AI-generated response in the inline chat interface. Shown as the text on a button in a confirmation dialog. When clicked, it confirms the deletion action and permanently removes the AI response. The purpose is to provide a clear action button for users to confirm they want to proceed with deleting the response.',
	},
	keepButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.keep-button.label',
		defaultMessage: 'Keep',
		description:
			'Button label displayed on the cancel/keep button in a confirmation dialog when the user is asked whether to delete an AI-generated response in the inline chat interface. Shown as the text on a button in a confirmation dialog. When clicked, it cancels the deletion action and keeps the AI response. The purpose is to provide a clear action button for users to cancel the deletion and retain the response.',
	},
	stopMessage: {
		id: 'ai-mate.inline-chat-input.warning-view.stop-message',
		defaultMessage: 'Stop request?',
		description:
			'Confirmation message displayed in a dialog or modal when a user attempts to stop an in-progress AI request in the inline chat interface. Shown as the main question text in a confirmation dialog. The purpose is to ask the user to confirm whether they want to stop the current AI request that is being processed, ensuring they understand the action will interrupt the response generation.',
	},
	yesButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.yes-button.label',
		defaultMessage: 'Yes',
		description:
			'Button label displayed on the confirm/yes button in a confirmation dialog when the user is asked to confirm an action (such as stopping a request or discarding a response) in the inline chat interface. Shown as the text on a button in a confirmation dialog. When clicked, it confirms the action and proceeds with stopping the request or discarding the response. The purpose is to provide a clear affirmative action button for users to confirm they want to proceed.',
	},
	noButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.no-button.label',
		defaultMessage: 'No',
		description:
			'Button label displayed on the cancel/no button in a confirmation dialog when the user is asked to confirm an action (such as stopping a request or discarding a response) in the inline chat interface. Shown as the text on a button in a confirmation dialog. When clicked, it cancels the action and continues with the current request or keeps the response. The purpose is to provide a clear negative action button for users to cancel the action and continue as normal.',
	},
});
export default _default_1;
